import { useQuery } from "@tanstack/react-query";
import { getItemsFromCollection } from "directus/src/operations";
import { getUserFields } from "components/user/config";

// Given an employee (reviewee) and a quadrimester, return the list of reviewers for that employee
export function useEmployeeReviewers({ employeeId, quadId, enabled = true }) {
  const query = useQuery({
    queryKey: ["employee-reviewers", quadId, employeeId],
    enabled: Boolean(enabled && quadId && employeeId),
    queryFn: async () => {
      const reviews = await getItemsFromCollection("performance_review", {
        fields: [
          getUserFields("reviewee"),
          getUserFields("reviewer"),
          "status",
        ],
        filter: {
          quadrimester: { _eq: quadId },
          reviewer: { _neq: employeeId },
          reviewee: { _eq: employeeId },
        },
        limit: -1,
      });
      // Return reviewers (employees doing the review)
      return (reviews || []).map((r) => r.reviewer).filter(Boolean);
    },
    staleTime: 60_000,
  });

  return { reviewers: query.data ?? [], isLoading: query.isLoading, ...query };
}
